<div
  class="main-container"
  [ngClass]="{
    'admin-cockpit': isAdminCockpit(),
    'partner-cockpit': isPartnerCockpit(),
    'cybersecurity-cockpit': isCustomerCockpit(),
  }"
>
  @if (isPartnerCockpit()) {
    <dbx-partner-navbar />
  } @else if (isAdminCockpit()) {
    <dbx-admin-navbar />
  } @else {
    <dbx-customer-navbar />
  }
  <div class="main-page">
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav
        [autoFocus]="false"
        [mode]="'side'"
        [opened]="true"
        [class.collapsed]="isCollapsed()"
        [class.locked]="!isMobile()"
        class="sidenav"
      >
        @if (isMobile()) {
          <button class="chevron-btn" (click)="toggleSidenav()" aria-label="Toggle sidebar">
            <mat-icon [class.rotated]="!isCollapsed()">chevron_right</mat-icon>
          </button>
        }

        <div class="sidenav-header">
          <div style="display: flex; justify-content: center; width: 100%">
            <img class="logo" [src]="'assets/images/logos/logo-inverse.png'" alt="Logo" />
          </div>
        </div>

        @if (this.showCockpitSwitch()) {
          <div class="cockpit-switch-menu">
            <button mat-flat-button [matMenuTriggerFor]="menu" class="sem-action">
              {{ 'navbar.switchCockpit' | translate }}
              <mat-icon fontIcon="arrow_drop_down" />
            </button>
          </div>

          <mat-menu #menu="matMenu">
            @if (this.canNavigateToPartnerCockpit()) {
              <a mat-menu-item [routerLink]="Paths.PARTNER_COCKPIT_PATH">
                <mat-icon fontIcon="handshake" />
                {{ 'navbar.partnersCockpit' | translate }}
              </a>
            }

            @if (this.canNavigateToCustomerCockpit()) {
              <a mat-menu-item [routerLink]="Paths.CYBERSECURITY_COCKPIT_PATH">
                <mat-icon fontIcon="domain" />
                {{ 'navbar.customerCockpit' | translate }}
              </a>
            }

            @if (this.canNavigateToAdminCockpit()) {
              <a mat-menu-item [routerLink]="Paths.ADMIN_COCKPIT_PATH">
                <mat-icon fontIcon="key"></mat-icon>
                {{ 'navbar.adminCockpit' | translate }}
              </a>
            }
          </mat-menu>
        }
        <h3 class="cockpit-header">
          @if (this.isPartnerCockpit()) {
            {{ 'navbar.partnersCockpit' | translate }}
          } @else if (this.isAdminCockpit()) {
            {{ 'navbar.adminCockpit' | translate }}
          } @else {
            {{ 'navbar.customerCockpit' | translate }}
          }
        </h3>

        @if (isPartnerCockpit()) {
          <dbx-partner-sidebar [isCollapsed]="isCollapsed()" />
        } @else if (isAdminCockpit()) {
          <dbx-admin-sidebar [isCollapsed]="isCollapsed()" />
        } @else {
          <dbx-customer-sidebar [isCollapsed]="isCollapsed()" />
        }
      </mat-sidenav>

      <mat-sidenav-content>
        <div class="content">
          <router-outlet />
        </div>
        <div class="footer">
          {{ app_versions() }}
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
